import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { UmsService } from '../ums.service';
import { ModalpopService } from '../modalpop.service';
import { Router } from '@angular/router';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { MatDialogRef } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';
import { MatDialog } from '@angular/material/dialog';
import { FeeHeadDialogBoxComponent } from '../fee-head-dialog-box/fee-head-dialog-box.component';
import { PageEvent } from '@angular/material/paginator';

@Component({
  selector: 'app-fees-head',
  templateUrl: './fees-head.component.html',
  styleUrls: ['./fees-head.component.scss']
})
export class FeesHeadComponent implements OnInit {
  APIService: string;
  FeeTemplateSearch: FormGroup;
  FeeHeadList: any;
  pageSize = 10;
  pageSizeOptions: number[] = [5, 10, 20];
  currentPage = 1;
  totalItems = 0;
  setIntervalSearch: any;
  constructor(
    public umsService: UmsService,
    private modalPopupService: ModalpopService,
    private dialog:MatDialog,
    private fb: FormBuilder,   public router: Router,  private httpClient: HttpClient,
   private spinner: NgxSpinnerService
     ) { this.APIService = environment.serviceUrl;}

     dialogRef: MatDialogRef<any>;
  ngOnInit(): void {
    this.getFeeHeadData();
    this.FeeTemplateSearch = this.fb.group({
      SearchString: new FormControl(''),
    });
  }

  onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize;
    const newPageIndex = event.pageIndex + 1;
    this.currentPage = newPageIndex;
    this.getFeeHeadData();
    this.keypress();
  }

  keypress() {
    if(this.setIntervalSearch){
      clearTimeout(this.setIntervalSearch);
    }
    this.setIntervalSearch = setTimeout(()=>{
      this.FeeHeadList = [];
      let payload = {}
      payload['SearchString'] = this.FeeTemplateSearch.value['SearchString'];
      payload['PageSize'] = this.pageSize;
      // payload['PageNumber'] = this.currentPage;
      if (payload['SearchString'] === "") {
        payload['PageNumber'] = this.currentPage;
      } else {
        payload['PageNumber'] = 1;
      }
      this.umsService.searchFeeHead(payload).subscribe(
        (res) => {
          if(res.status){
            this.FeeHeadList = res.data;
            this.totalItems = res.data[0].TotalRecords;
          }
          else{
            this.FeeHeadList = [];
          this.totalItems = 0;
          }
         
        }, (ERROR: HttpErrorResponse) => {
          this.FeeHeadList = [];
        });
    },1000)
    
  }

getFeeHeadData() {
  this.spinner.show();
    const payload = {};
    payload['PageSize'] = this.pageSize;
    payload['PageNumber'] = this.currentPage;
    this.umsService.getFeeHead(payload).subscribe(res => {
      this.spinner.hide();
    this.FeeHeadList = res.data;
    this.totalItems = res.data[0].TotalRecords;
    
        });
    }

 addnewrecord() {
  const dialogRef = this.dialog.open(FeeHeadDialogBoxComponent, {
    width: '75vh',
    data: {key : "New"},
    disableClose: true 
  }); 
  dialogRef.afterClosed().subscribe(result => {
    // Handle dialog close actions or data here
    this.getFeeHeadData();
    this.FeeTemplateSearch.controls['SearchString'].setValue('');
  });
}

editData(k){
  const dialogRef = this.dialog.open(FeeHeadDialogBoxComponent, {
    width: '75vh',
    data: { selected: k, key : "Edit"},
    disableClose: true 
  });
  dialogRef.afterClosed().subscribe(result => {
    // Handle dialog close actions or data 
      this.getFeeHeadData();
      this.FeeTemplateSearch.controls['SearchString'].setValue('');
  });
}

deleteData(k){
  const dialogRef = this.dialog.open(FeeHeadDialogBoxComponent, {
    width: '75vh',
    data: { selected: k, key : "Delete"},
    disableClose: true 
  });
  dialogRef.afterClosed().subscribe(result => {
    // Handle dialog close actions or data here
      this.getFeeHeadData();
      this.FeeTemplateSearch.controls['SearchString'].setValue('');
  });
}
}


